import { FormattedMessage, useIntl } from 'react-intl';
import { Link as RouterLink, useLocation } from 'react-router';

// material-ui
import { Grid, Link, Typography } from '@mui/material';

// trendio-selfcare-ui-kit
import { AlertCard } from '@trendiolive/trendio-selfcare-ui-kit';

import useAuth from 'hooks/useAuth';
import usePermissionsAlert from 'features/permissions/hooks/usePermissionsAlert';

import { ADD_PAYMENT_PATH, PRICING_PATH } from 'constants/routeConstants';

export default function SubscriptionAlert() {
  const { pathname } = useLocation();

  const { isLoading, merchant, tiktokPlan, youtubePlan } = usePermissionsAlert();

  function displayAlert() {
    const isNotAddPaymentPage = pathname !== ADD_PAYMENT_PATH;
    const isNotPricingPage = pathname !== PRICING_PATH;
    return merchantIsNotSubscribed() && isNotAddPaymentPage && isNotPricingPage;
  }

  function merchantIsNotSubscribed() {
    const notSubscribed = !tiktokPlan && !youtubePlan;
    const merchantIsCustomMerchant = merchant?.hidePlans === true;

    return notSubscribed && !merchantIsCustomMerchant;
  }

  if (!displayAlert() || isLoading) return null;

  return (
    <AlertCard title="activate-your-features">
      <Grid container alignItems="center" aria-label="Subscribe to a plan alert">
        <RenderMessage />
      </Grid>
    </AlertCard>
  );
}

function RenderMessage() {
  const { formatMessage } = useIntl();
  const { userRole } = useAuth();

  const values = () => {
    if (userRole === 'ADMIN') return `(${formatMessage({ id: 'free-trial-available' })})`;
    return `(${formatMessage({ id: 'contact-your-admin' })})`;
  };

  return (
    <Typography>
      <FormattedMessage id="you-need-to-subscribe" values={{ message: values() }} />
      {userRole === 'ADMIN' && (
        <>
          {' '}
          <Link component={RouterLink} to={PRICING_PATH} sx={{ color: 'white', fontWeight: 900 }}>
            <FormattedMessage id="subscribe-now" />
          </Link>
        </>
      )}
    </Typography>
  );
}
